// extracted by mini-css-extract-plugin
export var ncFooterTrustmateWidget = "nc-footer-trustmate-widget";
export var root = "Imqy";
export var rootAside = "meM8";
export var rootContainer = "Nnth";
export var rootLinks = "dkyf";
export var rootLinksAnchor = "_2IkB";
export var rootLinksColumn = "t7Fe";
export var rootLinksGrid = "hMkl";
export var rootLinksHeading = "-NEq";
export var rootLinksList = "l4pX";
export var rootMain = "_42bs";
export var rootNewsletter = "xU39";
export var rootTrustmate = "UEAS";
export var tmDodo2Grade = "tm-dodo2__grade";
export var tmDodo2Text = "tm-dodo2__text";